import * as React from "react";
// import { pure } from 'recompose';
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import * as Utils from "@Cyclope-Utils/index";
// import { Link } from 'react-router-dom';
// import * as Paths from '@tunnel-enums/index';
import * as cx from "classnames";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  const {
    Elem /*onClose,*/,
    // falseAlert,// startTimeAction,
    // onStartTimeAction,onFalseAlert,
    // onCameraSectionName,// cameraSection,
    onActive,
    arrayOfIncident, // onActiveOut,
    key,
    // incident,actionloading, onExtractImpact, onExtractVideo
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name i18next
   * @name react-router-dom
   * @infos "https://reactjs.org"
   */

  return (
    <section
      className={cx("arrayContent", { arrayContentActive: arrayOfIncident })}
      key={key}
      style={{ cursor: "pointer", height: "49px" }}
      onClick={onActive}
    >
      <span className="arraysContentSpanAuto" style={{ width: "12%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p>{Utils.localDateFrSecondFormat(Elem && Elem.insertedAt)}</p>
          </div>
          <Styled.BreadBoxContainer
            isVisible={true}
            style={{ width: "auto", top: "10px", color: "black" }}
            className="isVisible"
          >
            {Utils.localDateFrSecondFormat(Elem && Elem.insertedAt)}
          </Styled.BreadBoxContainer>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "11%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p>{Elem && Elem.cameraCode}</p>
          </div>
          <Styled.BreadBoxContainer
            isVisible={true}
            style={{ width: "auto", top: "10px", color: "black" }}
            className="isVisible"
          >
            <p>{Elem && Elem.cameraCode}</p>
          </Styled.BreadBoxContainer>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "11%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p style={{ color: "#007ADF" }}>{Elem && Elem.cameraName}</p>
          </div>
          <Styled.BreadBoxContainer
            isVisible={true}
            style={{ width: "auto", top: "10px", color: "black" }}
            className="isVisible"
          >
            <p>{Elem && Elem.cameraName}</p>
          </Styled.BreadBoxContainer>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "11%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p>{Elem && `${Elem.laneId}`}</p>
          </div>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "11%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p>{Elem && Elem.direction}</p>
          </div>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "11%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p style={{ color: "#007ADF" }}>{Elem && Elem.plate}</p>
          </div>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "11%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p>{Elem && Elem.commentary}</p>
          </div>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "11%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p>{Elem && Elem.confidence}</p>
          </div>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "11%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <span
              style={{
                cursor: "default",
                padding: "10px 0",
                width: "80px",
                fontSize: ".8em",
              }}
              className="arraysAction"
            >
              {Elem && Elem.nationality}
            </span>
          </div>
        </div>
      </span>
    </section>
  );
};

Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  Elem?: any;
  onActive?: any;
  arrayOfIncident?: any;
  key?: any;
  onActiveOut?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/box/lapi/component.tsx